import { Pagination } from 'react-admin';

export const TablePagination = ({
  rowsPerPageOptions = [5, 10, 25, 50, 100, 200],
  totalOverride = null
}) => (
  <Pagination rowsPerPageOptions={rowsPerPageOptions} total={totalOverride || undefined}/>
);
